/**
 * Výčet oblastí pro logování.
 */
export enum LoggingSection {
    // obecné oblasti
    app = "App",
    authentication = "Authentication",
    configuration = "Configuration",
    upload = "Upload",
    dependencyInjection = "DependencyInjection",
    formComponentsStructure = "FormComponentsStructure",
    control = "UI-Control",
    cryptoWebExtension = "CryptoWebExtension",
    customElements = "CustomElements",
    dataEvents = "DataEvents",
    objectWrapper = "ObjectWrapper",
    dataSource = "DataSource",
    download = "Download",
    editableControl = "EditableControl",
    encryption = "Encryption",
    enums = "Enums",
    filters = "Filters",
    formProfiles = "FormProfiles",
    formUI = "FormUI",
    frames = "Frames",
    globalContext = "GlobalContext",
    heartBeat = "HeartBeat",
    chartFrame = "ChartFrame",
    indexedDB = "IndexedDB",
    localizations = "Localizations",
    modelDescription = "ModelDescription",
    core = "Core",
    coreReact = "CoreReact",
    coreRedux = "CoreRedux",
    rights = "Rights",
    serviceWorker = "ServiceWorker",
    coreUI = "CoreUI",
    validation = "Validation",
    webSocket = "WebSocket",
    workerCommunicator = "WorkerCommunicator",
    multiEditing = "MultiEditing",
    autosave = "AutoSave",
    userSettings = "UserSettings",
    dataFormatRegistrator = "DataFormatRegistrator",

    // XG komponenty (https://teaf.tescosw.cz/wiki/index.php?title=Ovl%C3%A1dac%C3%AD_prvky_-_seznam)
    detailFormAction = "DetailFormAction",
    calendarFrame = "CalendarFrame",
    commentaryFrame = "CommentaryFrame",
    cryptoAction = "CryptoAction",
    dataEventLabel = "DataEventLabel",
    dataLabel = "DataLabel",
    detailFrame = "DetailFrame",
    edit = "Edit",
    fileEdit = "FileEdit",
    form = "Form",
    infoLabel = "InfoLabel",
    listFrame = "ListFrame",
    liteListFrame = "LiteListFrame",
    lOVEdit = "LOVEdit",
    textLOVEdit = "TextLOVEdit",
    memo = "Memo",
    methodAction = "MethodAction",
    mslov = "MSLOV", // MultiSelectLOV
    objectListEdit = "ObjectListEdit",
    parametricFormAction = "ParametricFormAction",
    radioGroup = "RadioGroup",
    separateDetailFrame = "SeparateDetailFrame",
    showInsertAction = "ShowInsertAction",
    treeFrame = "TreeFrame",
    treeViewFrame = "TreeViewFrame",
    twoListFrame = "TwoListFrame",
    alignPanel = "AlignPanel",
    linkButton = "LinkButton",

    // další komponenty
    dataGrid = "DataGrid",
    dropDown = "DropDown",
    mainMenu = "MainMenu",
    unsupportedComponent = "UnsupportedComponent",
    sidePanel = "SidePanel",
    widget = "Widget",
    dataGridColumn = "DataGridColumn",
    numEdit = "NumEdit",
    reactControlConnector = "ReactControlConnector",
    xgAction = "XGAction",
    gridLayout = "GridLayout",
    exportImportFrame = "ExportImportFrame",
}
